import { ISendingMessage, IMailingResult } from '@interfaces/ISendingMessage';

export interface IMailingState {
  errors: { [key: string]: { [key: string]: string[] } };
  mailings: ISendingMessage[];
  loading: { [key: string]: boolean };
  selectMailing?: ISendingMessage;
  results: IMailingResult[];
}

export const initialMailingsState: IMailingState = {
  errors: {},
  mailings: [],
  results: [],
  loading: {},
};
